export const SET_MASSNOTIFICATION_ENVIRONMENT = 'SET_MASSNOTIFICATION_ENVIRONMENT';
export const SUBSCRIBE_TO_MASSNOTIFICATION = 'SUBSCRIBE_TO_MASSNOTIFICATION';
export const UNSUBSCRIBE_TO_MASSNOTIFICATION = 'UNSUBSCRIBE_TO_MASSNOTIFICATION';
export const SET_MASSNOTIFICATION_AUTH_TOKEN = 'SET_MASSNOTIFICATION_AUTH_TOKEN';
export const MASSNOTIFICATION_UPDATED_MESSAGE = 'MASSNOTIFICATION_UPDATED';
